@if (modalRef.data?.id === firstStep) {
  @if (!showTerms) {
    <ng-container *ngTemplateOutlet="welcomeTemplate" />
  } @else {
    <ng-container *ngTemplateOutlet="termsTemplate" />
  }
} @else {
  @if (modalRef.data?.image) {
    <img [cdsSource]="modalRef.data?.image" alt="{{ modalRef.data?.titleModal }}">
  }
  <p [innerHTML]="modalRef.data?.body"></p>
}

<cds-step-carousel
  [stepOptions]="(modalRef.data?.id !== firstStep) ? (listOptions$ | async) : null"
  [showPrevious]="!(modalRef.data?.id === firstStep) && !(modalRef.data?.id === 'welcome')"
  [showNext]="!(modalRef.data?.id === firstStep) && !(modalRef.data?.id === 'openFinance')"
  [nextLabel]="null"
  [previousLabel]="null"
  [isRadioInputInteractive]="false"
  (transitionToStep)="transitionToStep($event)"
  (skipToEnd)="goToLastStep()"
/>

@if (!(isLastStep$ | async) && !(modalRef.data?.id === firstStep)) {
  <button
    class="cds-button s-plain c-initial text-jump"
    (click)="goToLastStep()"
  >
    Pular
  </button>
}

@if (!(modalRef.data?.id === firstStep && showTerms)) {
  <div class="button-footer">
    @if (modalRef.data?.labelSecondaryButton) {
      <button
        class="c-primary cds-button s-hollow w-stretch"
        (click)="closeModal()">
        {{ modalRef.data?.labelSecondaryButton }}
      </button>
    }

    @if (modalRef.data?.labelPrimaryButton) {
      <button
        class="cds-button s-solid c-primary"
        [class.w-stretch]="modalRef.data?.id !== firstStep"
        cdsButtonLoading
        [loading]="loading$ | async"
        (click)="modalRef.data?.id === firstStep ? acceptTerms() : connectAccountsOpenFinance()"
      >
        {{ modalRef.data?.labelPrimaryButton }}
      </button>
    }
  </div>
}

<!-- View de aceite: "Acesse GRATUITAMENTE o Meu CAIXA" -->
<ng-template #welcomeTemplate>
  <div class="welcome">
    <h4 class="welcome-title">{{ modalRef.data?.welcomeTitle }}</h4>
    <p class="welcome-subtitle">{{ modalRef.data?.welcomeSubtitle }}</p>
    @if (modalRef.data?.welcomeSubtitleSecondary) {
      <p class="welcome-subtitle" [innerHTML]="modalRef.data?.welcomeSubtitleSecondary"></p>
    }

    <p class="welcome-subtitle welcome-consent">
      {{ modalRef.data?.termsConsentPrefix }}<button
        type="button"
        class="link-terms"
        (click)="viewTerms()"
      >{{ modalRef.data?.termsLinkLabel }}</button>.
    </p>
  </div>
</ng-template>

<!-- Sub-tela de termos (acessada pelo link, com Voltar) -->
<ng-template #termsTemplate>
  <div class="terms-view">
    <button
      type="button"
      class="cds-button s-hollow c-primary back-button"
      (click)="backToWelcome()"
    >
      Voltar
    </button>

    @if (checkFirstAccess?.isLoadingTerm()) {
      <caixa-webcomponent-shimmer
        width="420px"
        height="20px"
        borderRadius="4px"
        marginBottom="8px"
        [lines]="12"
      />
    } @else {
      <div class="text-scroll terms-scroll">
        <div class="text-accept-term" [innerHTML]="modalRef.data?.body"></div>
      </div>
    }
  </div>
</ng-template>
